<template>
  <table-view
    class="wechat-merchant-manage"
    :total="total"
    :query-info.sync="queryInfo"
    @reload-table="renderTable">
    <template #header>
      <view-search-form
        keyword-placeholder="微信商户名称"
        :queryInfo.sync="queryInfo"
        :tool-list="['keyword']"
        @on-search="renderTable(1)" />
      <div v-permission="['wechat:shop:add']" class="header-button">
        <el-button type="primary" plain size="small" @click="visibleScheduleDialog=true"
        >微信商户定时器管理
        </el-button>
        <el-button type="primary" size="small" @click="showDialog()"
        >添加微信商户
        </el-button>
      </div>
    </template>
    <!-- body -->
    <el-table :data="tableData" style="width: 100%" border stripe>
      <el-table-column type="index" label="ID" width="50" align="center" />
      <el-table-column prop="name" label="微信商户名" width="160" />
      <el-table-column prop="mchId" label="微信商户id" width="200" />
      <el-table-column prop="appId" label="开放平台appId" width="200" />
      <el-table-column prop="certSerialNo" label="证书编号" width="360" />
      <el-table-column prop="remarks" min-width="200" label="备注" />
      <el-table-column label="是否启用" width="100" fixed="right" align="center">
        <template v-slot="{ row }">
          <el-switch
            v-if="isEditor"
            :disabled="!!+row.enable"
            v-model="row.enable"
            active-color="var(--color-success)"
            inactive-color="#d7deea"
            :active-value="1"
            active-text=""
            :inactive-value="0"
            inactive-text=""
            @change="handleSwitch(row)" />
          <el-tag :type="+row.enable?'success':'info'"
                  v-else>
            {{ row.enable ? '启用' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="130" fixed="right">
        <template v-slot="{ row }">
          <template v-if="!+row.enable">
            <el-button v-if="isEditor"
                       type="primary"
                       size="mini"
                       @click="showDialog(row.id)"
            >编辑
            </el-button>
            <el-button v-permission="['wechat:shop:del']"
                       size="mini"
                       type="danger"
                       @click="del(delWechatMerchantByIdApi, row.id,`微信商户-${row.name}`)"
            >删除
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!--    微信商户编辑弹窗    -->
    <DialogWechatMerchant ref="dialogRef"
                          :visible.sync="visibleDialog" v-if="visibleDialog"
                          @on-close="renderTable" />
    <!--    微信商户 定时器 弹窗    -->
    <DialogWxMchSchedule ref="scheduleDialogRef"
                         :visible.sync="visibleScheduleDialog"
                         v-if="visibleScheduleDialog"
                         :wx-mch-list="tableData"
                         @on-close="renderTable" />
  </table-view>
</template>

<script>
import tableView from '@/vue/mixins/table-view'
import {
  delWechatMerchantByIdApi,
  enableWechatMerchantApi,
  pageWechatMerchantApi
} from '@/api/finance-manage/wechat-merchant-manage-api'
import DialogWechatMerchant from '@/views/pages/financeManage/wechat-merchant-manage/component/DialogWechatMerchant.vue'
import DialogWxMchSchedule from '@/views/pages/financeManage/wechat-merchant-manage/component/DialogWxMchSchedule.vue'

export default {
  name: 'WechatMerchantManage',
  components: { DialogWxMchSchedule, DialogWechatMerchant },
  mixins: [tableView],
  data() {
    return {
      isEditor: false, // 编辑状态禁止跳转切换
      visibleScheduleDialog: false,
      queryInfo: {
        grade: new Date().getFullYear(),
        collegeId: null,
        majorId: null,
        campusId: null,
        pageSize: 100
      }
    }
  },
  created() {
    this.isEditor = this.$store.state.login.permissionTable.includes('wechat:shop:edit')
  },
  methods: {
    delWechatMerchantByIdApi, // 删除api
    // 获取班级list
    async renderTable(pageNum) {
      await this.getTableData(pageWechatMerchantApi, pageNum)
    },
    async handleSwitch(row) {
      this.$confirm(`此操作将<b>启用</b><b class="font-primary">${row.name}</b>，并同时停用其他商户号，是否继续?`, '提示', { dangerouslyUseHTMLString: true }).then(async () => {
        try {
          await enableWechatMerchantApi(row.id)
          this.$message.success(`操作成功,当前启用商户为：${row.name}`)
          await this.renderTable(1)
        } catch (e) {
          console.error(e)
        }
      })
    }
  }
}
</script>
